// extracted by mini-css-extract-plugin
module.exports = {"formulario":"ApresentarDadosPaciente_formulario__3SmB9"};